import type { InventoryRemoveFormik } from '../InventoryRemoveFormik';

export const createEmptyRemoveFormik = (): InventoryRemoveFormik => ({
  singleCuUnits: '',
  singleDpUnits: '',
  fullDuUnits: '',
});
